export default {
  MOBILE_BREAKPOINT: 768,
};
